import { useSelector } from 'react-redux';
import { SUB_VIEW_MODEL } from '../../Model/Models';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import SearchSimple from "../../../../../components/SearchSimples/SearchSimple";
import { permissionObj } from '../../../../../Helpers/permission';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const RequestHeader = (props) => {
    const {
        optionView,
        handleBtnRequest,
        handleBtnHistory,
        searchId,
        setBodyForExport,
        setResults,
        results,
        searchElement,
        setSearchElement,
        option,
        rowsPerPage,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        getData
    } = props;

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Each subview is guarded by its own read permission
    const canReadRequest = DEV || permission?.includes(permissionObj?.WEB_FOODIE_REQUEST_READ);
    const canReadHistory = DEV || permission?.includes(permissionObj?.WEB_FOODIE_REQUEST_HISTORY_READ);

    return (
       <div className='d-flex gap-2 mb-2'>
            {canReadRequest && (
                <ButtonAction
                    id='btn_rh_requested_meals'
                    name='requested_meals'
                    className={
                        SUB_VIEW_MODEL.REQUEST.REQUEST === optionView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnRequest();
                    }}
                />
            )}
            {canReadHistory && (
                <ButtonAction
                    id='btn_rh_history'
                    name='history'
                    className={
                        SUB_VIEW_MODEL.REQUEST.HISTORY === optionView
                            ? 'btn-outlined-secondary-600-100'
                            : 'btn-outlined-secondary-600-00'
                    }
                    disabled={false}
                    splitName={false}
                    onClick={() => {
                        handleBtnHistory();
                    }}
                />
            )}

           <div className='flex-grow-1'>
               <SearchSimple
                   id={searchId}
                   setBodyForExport={setBodyForExport}
                   setSearchResults={setResults}
                   searchResults={results}
                   searchElement={searchElement}
                   setSearchElement={setSearchElement}
                   optionTable={option}
                   rowsPerPage={rowsPerPage}
                   setSearch={setSearch}
                   simpleSearch={simpleSearch}
                   setSimpleSearch={setSimpleSearch}
                   contractorId={null}
                   supplierId={null}
                   callApi={ getData ? () => getData(0, { searchElement}) : undefined }
                   resetApi={ getData ? () => getData(0, {searchElement: ''}) : undefined }
               />
           </div>
        </div>
    );
};
